import React, { useEffect, useState } from "react";
import erp from "../assets/icons/erp-icon.svg";
import order from "../assets/icons/order-icon.svg";
import dashboard from "../assets/icons/dashboard-icon.svg";
import product from "../assets/icons/product-icon.svg";
import user from "../assets/icons/user-icon.svg";
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";

const LeftSideBar = ({
  isVisible,
  toggleSidebar,
  isCollapsed,
  toggleCollapse,
}) => {
  const [active, setActive] = useState("/dashboard");

  const navigation = [
    {
      title: "Products",
      icon: product,
      url: "/admin/product-listing",
    },
    {
      title: "Orders & Returns",
      icon: order,
      url: "/admin/orders",
    },
    {
      title: "Users",
      icon: user,
      url: "/admin/users",
    },
  ];

  const onTabSelect = (value) => {
    setActive(value);
    // router.push(value);
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname) {
      setActive(pathname);
    }
  }, []);

  return (
    <div
      className={`fixed h-screen z-40 top-0 left-0 bottom-0 flex flex-col pt-30 bg-[#F87315] duration-500 px-6
      ${isVisible ? "translate-x-0" : "-translate-x-full"}
      ${isCollapsed ? "w-16" : "w-72"}
      md:h-screen md:top-0 md:left-0 md:translate-x-0 md:visible overflow-hidden md:relative`}
    >
      <div className="mt-6 mb-7 flex items-center gap-3">
        <button
          className={`absolute text-[#F0F5FF] hidden md:block ${isCollapsed ? "items-center": "right-4"}`}
          onClick={toggleCollapse}
        >
          {isCollapsed ? <HiChevronDoubleRight /> : <HiChevronDoubleLeft />}
        </button>
        <button
          className="md:hidden text-[#F0F5FF] absolute right-4"
          onClick={toggleSidebar}
        >
          <HiX />
        </button>
      </div>

      {navigation.map((item, index) => (
        <Link
          className={`flex w-full my-3 items-center gap-3 ${
            active === item.url ? "!text-primary-1" : "text-[#F0F5FF]"
          }`}
          key={index}
          to={item.url}
        >
          <img src={item.icon} className="h-4 w-4" alt={item.icon} />
          {!isCollapsed && (
            <span className="text-base leading-4">{item.title}</span>
          )}
        </Link>
      ))}
    </div>
  );
};

export default LeftSideBar;
